// Auto-generated from menu-item.json
export default {
  "tagName": "menu-item",
  "content": [
    "icon",
    "label",
    "badge",
    "href",
    "value"
  ],
  "contentAttributes": [
    "icon",
    "label",
    "badge",
    "href",
    "value"
  ],
  "states": [
    "hover",
    "focused",
    "active",
    "disabled"
  ],
  "attributes": [
    "icon",
    "label",
    "badge",
    "href",
    "value",
    "hover",
    "focused",
    "active",
    "disabled"
  ],
  "propertyTypes": {
    "icon": "string",
    "label": "string",
    "badge": "string",
    "href": "string",
    "value": "string",
    "hover": "boolean",
    "focused": "boolean",
    "active": "boolean",
    "disabled": "boolean"
  },
  "attributeClasses": [
    "icon"
  ]
};
